import { render } from "./InsightsTrendsView.vue?vue&type=template&id=a8f12d6c&ts=true"
import script from "./InsightsTrendsView.vue?vue&type=script&lang=ts"
export * from "./InsightsTrendsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__